import { Briefcase, Info } from "@phosphor-icons/react";
import { ScrollArea } from "@reactive-resume/ui";
import { useResumeStore } from "@/client/stores/resume";

export const JobDescription = () => {
  const title = useResumeStore((state) => state.resume.title);
  const jobDescription = useResumeStore((state) => state.resume.job?.description);

  return (
    <ScrollArea orientation="vertical" className="h-screen flex-1 px-4 [&>div]:py-20">
      {/* Header Section */}
      <div className="bg-secondary-accent/70 mb-6 flex flex-col items-center gap-y-3 rounded-lg p-4 font-semibold">
        <div className="flex items-center gap-x-2">
          <Briefcase size={20} className="text-primary" />
          <span>{title}</span>
        </div>
      </div>

      {/* Job Description Section */}
      <div className="space-y-4">
        <div className="bg-background border-border rounded-lg border shadow-sm">
          {jobDescription ? (
            <div className="p-6">
              <div className="prose prose-sm dark:prose-invert max-w-none">
                <div className="text-foreground text-sm leading-relaxed whitespace-pre-wrap">
                  {jobDescription}
                </div>
              </div>
            </div>
          ) : (
            <div className="flex flex-col items-center justify-center px-6 py-12 text-center">
              <div className="bg-muted/50 mb-4 rounded-full p-3">
                <Info size={24} className="text-muted-foreground" />
              </div>
              <h3 className="text-foreground mb-2 text-lg font-medium">
                No Job Description Available
              </h3>
              <p className="text-muted-foreground max-w-md text-sm">
                Import a resume with a job description or add one during the resume creation process
                to see it displayed here.
              </p>
            </div>
          )}
        </div>
      </div>
    </ScrollArea>
  );
};
